import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../components/MainBody/MainBody";
import MainTabList from "../../components/MainBody/MainTabList";
import { useTrust } from "../../lib/context/TrustContext";
import Enrol from "./Enrol/Enrol";
import Program from "./Program/Program";
import CDD from "./CDD/CDD";
import Incidents from "./Incidents/Incidents";
import Training from "./Training/Training";
import Knowledgebase from "./Knowledgebase/Knowledgebase";
import GovernanceFramework from "./Governance Framework/GovernanceFramework";

const tabsKey = [
  {
    name: "Enrol",
    tabName: "enrol",
    value: 1,
  },
  {
    name: "Governance",
    tabName: "governance-framework",
    value: 7,
  },
  {
    name: "Program",
    tabName: "program",
    value: 2,
  },
  {
    name: "Training",
    tabName: "training",
    value: 5,
  },
  {
    name: "CDD",
    tabName: "cdd",
    value: 3,
  },
  {
    name: "Report Activities",
    tabName: "incidents",
    value: 4,
  },
  {
    name: "Knowledgebase",
    tabName: "knowledgebase",
    value: 6,
  },
];

const AMLCTFTabs = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "enrol";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const navigate = useNavigate();

  const { trustId } = useTrust();

  useEffect(() => {
    navigate(
      `/aml-ctf?tab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate, trustId]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        mainClassName="w-[calc(100%-3rem)]"
        mainTitle={"AML/CTF"}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative sm:max-h-[725px] overflow-auto`}
        >
          {activeTab === 1 ? (
            <Enrol />
          ) : activeTab === 2 ? (
            <Program />
          ) : activeTab === 3 ? (
            <CDD />
          ) : activeTab === 4 ? (
            <Incidents />
          ) : activeTab === 5 ? (
            <Training />
          ) : activeTab === 6 ? (
            <Knowledgebase />
          ) : activeTab === 7 ? (
            <GovernanceFramework />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default AMLCTFTabs;
